import { useState,useEffect } from "react";
import { useLocation } from 'react-router-dom';
function formatNumberWithCommasAndFontWeight(value) {
  const formattedValue = parseFloat(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const parts = formattedValue.split(".");
  const integerPart = parts[0];
  const decimalPart = parts[1];

  return (
    <span style={{ fontWeight: 700 }}>
      {integerPart}.<span style={{ fontWeight: 400 }}>{decimalPart}</span>
    </span>
  );
}
function formatPercentage(value) {
  // Convert string to a number
  const numValue = parseFloat(value);
  // Round to one significant figure
  const roundedValue = numValue.toPrecision(3);
  // Format to 000.0% format
  const formattedValue = parseFloat(roundedValue).toFixed(1) + "%";
  return formattedValue;
}
function notFloat(value) {
  return isNaN(parseFloat(value));
}

function calculateFibb(trend, high, low, constant, setExtensions, setRetracements) {
  if (notFloat(high) || notFloat(low) || notFloat(constant)) {
      setRetracements([
          { level: "23.6%", value: "-" },
          { level: "38.2%", value: "-" },
          { level: "50.0%", value: "-" },
          { level: "61.8%", value: "-" },
          { level: "76.4%", value: "-" },
      ]);
      setExtensions([
          { level: "200.0%", value: "-" },
          { level: "185.4%", value: "-" },
          { level: "176.4%", value: "-" },
          { level: "161.8%", value: "-" },
          { level: "150.0%", value: "-" },
          { level: "138.2%", value: "-" },
          { level: "127.2%", value: "-" },
      ]);
      return;
  }

  const fibRetracementLevels = [23.6, 38.2, 50, 61.8, 76.4];
  const fibExtensionLevels = [200.0, 185.4, 176.4, 161.8, 150.0, 138.2, 127.2];
  const retracements = [];
  const extensions = [];

  if (trend.toLowerCase() === 'uptrend') {
      fibRetracementLevels.forEach(level => {
          const value = high - ((high - low) * (level / 100));
          retracements.push({ level: level + "%", value: parseFloat(value) });
      });
      fibExtensionLevels.forEach(level => {
          const value = constant + ((high - low) * (level / 100));
          extensions.push({ level: level + "%", value: parseFloat(value) });
      });
  } else if (trend.toLowerCase() === 'downtrend') {
      fibRetracementLevels.forEach(level => {
          const value = low + ((high - low) * (level / 100));
          retracements.push({ level: level + "%", value: parseFloat(value) });
      });
      fibExtensionLevels.forEach(level => {
          const value = constant - ((high - low) * (level / 100));
          extensions.push({ level: level + "%", value: parseFloat(value) });
      });
  } else {
      console.error('Invalid trend type. Please use "uptrend" or "downtrend".');
  }

  setRetracements(retracements);
  setExtensions(extensions);
  console.log(retracements, extensions, high, low, constant);
}

 
export default function Fibonacci() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const theme = params.get('theme');
  console.log(theme)
  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [theme]);


  const [Trend, setTrend] = useState("Uptrend");
  const [High, setHigh] = useState(null);
  const [Low, setLow] = useState(null);
  const [Constant, setConstant] = useState(null);
  const [Retracements, setRetracements] = useState([
    { level: "23.6%", value: "-" },
    { level: "38.2%", value: "-" },
    { level: "50.0%", value: "-" },
    { level: "61.8%", value: "-" },
    { level: "76.4%", value: "-" },
  ]);

  const [Extensions, setExtensions] = useState([
  
    { level: "200.0%", value: "-" },
    { level: "185.4%", value: "-" },
    { level: "176.4%", value: "-" },
    { level: "161.8%", value: "-" },
    { level: "150.0%", value: "-" },
    { level: "138.2%", value: "-" },
    { level: "127.2%", value: "-" },
  ]);
  const items = ["Trend", "High (a)", "Low (b)", "Constant"];
  return (
    <div className="fullOuter flex flex-col justify-center">
        
        <label className="main-headding">Fibonacci retracement calculator</label>
        <label className="scndrylbl">
          Fibonacci retracement and extensions
        </label>
        <div className="wholecomp zoomout80-2">
          <div className="inputflexfib">
            <div className="inputdivs">
              <label className="inplabels">{items[0]}</label>
              <select value={Trend} onChange={(e) => setTrend(e.target.value)}>
                <option value="Uptrend">Uptrend</option>
                <option value="Downtrend">Downtrend</option>
              </select>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[1]}</label>{" "}
              <input
                type="text"
                value={High}
                onChange={(e) => setHigh(e.target.value)}
              ></input>
            </div>

            <div className="inputdivs">
              <label className="inplabels">{items[2]}</label>{" "}
              <input
                type="text"
                value={Low}
                onChange={(e) => setLow(e.target.value)}
              ></input>
            </div>
            <div className="inputdivs">
              <label className="inplabels">{items[3]}</label>{" "}
              <input
                type="text"
                value={Constant}
                onChange={(e) => setConstant(e.target.value)}
              ></input>
            </div>

            <button onClick={()=>calculateFibb(Trend,parseFloat(High),parseFloat(Low),parseFloat(Constant),setExtensions,setRetracements)}>Calculate</button>
          </div>
          <div className="tabelfibb">
            <label>Retracements</label>
            <table className="w-100 pivot-level-table">
              <colgroup>
                <col style={{ width: "50%" }} />
                <col style={{ width: "50%" }} />
              </colgroup>

              <tbody>
                {Retracements.map((val, index) => (
                  <tr key={index} className=" table-text  border-bottom-stock-detail">
                    <td className="table-text px-4 py-2 text-right text-start">
                      {val.level !== "-" ? formatPercentage(val.level) : "-"}
                    </td>
                    <td className=" table-text px-4 py-2 text-right text-end">
                      {val.value !== "-" ? val.value.toFixed(2) : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="tabelfibb">
            <label>Extensions</label>
            <table className="w-100 pivot-level-table">
              <colgroup>
                <col style={{ width: "50%" }} />
                <col style={{ width: "50%" }} />
              </colgroup>

              <tbody>
                {Extensions.map((val, index) => (
                  <tr key={index} className="border-bottom-stock-detail">
                    <td className="px-4 py-2 text-right text-start">
                      {val.level !== "-" ? formatPercentage(val.level): "-"}
                    </td>
                    <td className="px-4 py-2 text-right text-end">
                      {val.value !== "-" ? val.value.toFixed(2) : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

  );
}
